<template>
  <piece-card title="部门消耗">
    <div class="consume-list flex-box">
      <div class="consume-item flex-grow" v-for="(item, index) in list" :key="index">
        <div class="consume-chart flex-box align-center">
          <div class="consume-title">{{ item.title }}</div>
          <chart :option="item.option" />
        </div>
        <div class="room-list">
          <div class="room-item" v-for="(r, i) in item.list" :key="i">{{ r.room }} {{ r.value }}</div>
        </div>
      </div>
    </div>
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";

export default {
  name: "DeptConsume",
  components: {
    PieceCard,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {
      list: [
        {
          title: "用电",
          unit: "kw·h",
          option: {},
          list: [
            { room: "静心居", value: 12 },
            { room: "青云轩", value: 14 },
            { room: "松涛轩", value: 13 },
            { room: "佛香居", value: 14 },
            { room: "云中轩", value: 13 },
          ],
        },
        {
          title: "用水",
          unit: "m³",
          option: {},
          list: [
            { room: "静心居", value: 20 },
            { room: "青云轩", value: 25 },
            { room: "松涛轩", value: 23 },
            { room: "佛香居", value: 22 },
            { room: "云中轩", value: 24 },
          ],
        },
      ],
    };
  },
  created() {
    this.list.forEach((item) => {
      const total = item.list.reduce((sum, cur) => {
        return sum + cur.value;
      }, 0);
      item.option = this.getOption(0.6, total, "总能耗", item.unit);
    });
  },
  methods: {
    getOption(value, data, title, unit) {
      const option = {
        series: [
          {
            type: "liquidFill",
            radius: "90%",
            center: ["50%", "45%"],
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#FFE2AB",
                  },
                  {
                    offset: 1,
                    color: "#CEA34F",
                  },
                ],
                globalCoord: false,
              },
            ],
            data: [value], // data个数代表波浪数
            backgroundStyle: {
              borderWidth: 1,
              color: "rgba(255, 255, 255, 0.1)",
            },
            amplitude: 4,
            period: 1500,
            label: {
              fontSize: 10,
              color: "#fff",
              lineHeight: 14,
              backgroundColor: "rgba(0, 0, 0, 0.30)",
              borderRadius: 6,
              padding: [4, 4],
              formatter() {
                return `${title}\n${data}${unit}`;
              },
            },
            outline: {
              show: true,
              borderDistance: 2,
              itemStyle: {
                borderWidth: 2,
                borderColor: "rgba(255, 255, 255, 0.1)",
              },
            },
          },
        ],
      };
      return option;
    },
  },
};
</script>

<style lang="less" scoped>
.consume-list {
  margin-top: -4px;
}
.consume-item {
  &:not(:last-of-type) {
    margin-right: 12px;
  }
}
.consume-title {
  color: #fff;
  font-family: "PingFang SC";
  font-size: 14px;
  white-space: nowrap;
}
.consume-chart {
  height: 70px;
}
.room-item {
  height: 16px;
  line-height: 16px;
  text-align: center;
  color: #f9e6b3;
  font-family: "Source Han Sans CN";
  font-size: 12px;
  background-color: rgba(249, 230, 179, 0.3);
  &:not(:last-of-type) {
    margin-bottom: 1px;
  }
}
</style>
